<template>
  <div>
    <CallBucketPromptModal
      v-if="callPromptData"
      :show="showCallPrompt"
      :contact-id="callPromptData.contactId"
      :contact-name="callPromptData.contactName"
      :call-log-id="callPromptData.callLogId"
      :duration="callPromptData.duration"
      @close="dismissCallPrompt"
      @create="handleCreateTask"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useQueryClient } from "@tanstack/vue-query";
import { useBucketWebhooks } from "@/composables/bucket/useBucketWebhooks";
import { showLinkedInConnectionNotification } from "@/services/bucket/bucket-notifications";
import CallBucketPromptModal from "./CallBucketPromptModal.vue";
import type {
  BucketAutoCreatedPayload,
  BucketPromptManualPayload,
  LinkedInConnectionAcceptedPayload,
} from "@/dtos/BucketWebhook.dto";

const queryClient = useQueryClient();
const showCallPrompt = ref(false);
const callPromptData = ref<BucketPromptManualPayload | null>(null);

const { setupSocket, cleanupSocket } = useBucketWebhooks({
  onBucketAutoCreated: (_payload: BucketAutoCreatedPayload) => {
    queryClient.invalidateQueries({ queryKey: ["dashboardStats"] });
  },
  onBucketPromptManual: (payload: BucketPromptManualPayload) => {
    callPromptData.value = payload;
    showCallPrompt.value = true;
  },
  onLinkedInConnectionAccepted: (payload: LinkedInConnectionAcceptedPayload["payload"]) => {
    showLinkedInConnectionNotification(payload);
  },
});

const dismissCallPrompt = () => {
  showCallPrompt.value = false;
  callPromptData.value = null;
};

const handleCreateTask = (callLogId: string, contactId: string) => {
  dismissCallPrompt();
};

onMounted(() => {
  setupSocket();
});

onUnmounted(() => {
  cleanupSocket();
});
</script>
